<template>
  <div>
    <PageTitle
      featureName="sites"
      functionName="List"
      :pageName="$options.name"
    />

    <v-container fluid>
      <v-card v-if="siteList.length > 0">
        <v-card-title><div class="subtitle-2">Sites</div></v-card-title>
        <v-card-text>
          <SiteListItemCard
            v-for="item in siteList"
            :key="item.SiteId"
            :item="item"
            @click="siteListItemClickEvent"
          />
        </v-card-text>
      </v-card>
    </v-container>

    <v-dialog v-model="showSiteCardDialog">
      <SiteCard
        :isDialogOpen="showSiteCardDialog"
        :siteId="selectedSiteId"
        @close="siteCardCloseEvent"
        @update="siteCardUpdateEvent"
      />
    </v-dialog>

    <DialogUtil ref="dialogUtil" />
  </div>
</template>

<script>
import { ref } from 'vue'
import { feature, icon } from '@/use/Constants'
import { host } from '@/services/HostAPI'
import { todayISOString } from '@/use/DateFormatter'
import SiteCard from '@/components/Site/SiteCard'
import SiteListItemCard from '@/components/Site/SiteListItemCard'
import { userData } from '@/store/UserSession'
export default {
  name: 'SitesPage',
  components: {
    SiteCard,
    SiteListItemCard
  },
  setup() {
    const dialogUtil = ref(null)

    const siteList = ref([])
    const showSiteCardDialog = ref(false)
    const selectedSiteId = ref()
    const cardData = ref()

    const siteListItemClickEvent = async siteId => {
      selectedSiteId.value = siteId
      showSiteCardDialog.value = true
    }

    const siteCardCloseEvent = () => {
      showSiteCardDialog.value = false
    }

    const siteCardUpdateEvent = () => {
      showSiteCardDialog.value = false
      refreshSearch()
    }

    const editRecurringSiteEvent = () => {}

    const initForm = () => {
      refreshSearch()
    }

    const refreshSearch = async () => {
      const rq = {
        Criteria: {
          LoginName: null,
          UserId: userData.value.UserId,
          ServiceDate: todayISOString(),
          CustomerId: null
        }
      }
      const rs = await host.site.list(rq)
      if (rs.InfoList.length > 0) {
        siteList.value = rs.InfoList
      }
    }

    initForm()

    return {
      dialogUtil,
      feature,
      icon,
      siteList,
      siteListItemClickEvent,
      refreshSearch,
      selectedSiteId,
      cardData,
      editRecurringSiteEvent,
      showSiteCardDialog,
      siteCardCloseEvent,
      siteCardUpdateEvent
    }
  }
}
</script>

<style lang="scss" scoped></style>
